import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DateFormatPipe } from './pipes/date-format.pipe';
import { DBConfig, NgxIndexedDBModule } from 'ngx-indexed-db';
import { GlobalSearchComponent } from './components/global-search/global-search.component';
import { AdvancedSearchComponent } from './components/advanced-search/advanced-search.component';
import { CustomDropdownComponent } from './components/common-components/custom-dropdown';
import { CommonDatePickerComponent } from './components/common-date-picker/common-date-picker.component';
import { CommonDropdownComponent } from './components/common-dropdown/common-dropdown.component';
import { DateRangePickerComponent } from './components/date-range-picker/date-range-picker.component';

// DateFormatPipe is now standalone and should not be declared or exported in an NgModule.

@NgModule({
  declarations: [
    GlobalSearchComponent,
    AdvancedSearchComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CustomDropdownComponent,
    CommonDatePickerComponent,
    CommonDropdownComponent,
    DateRangePickerComponent
  ],
  exports: [
    GlobalSearchComponent,
    AdvancedSearchComponent
  ]
})
export class SharedModule {}